<template>
  <div>
    <button 
      @click="showModal = true"
      class="smsir-login-button"
      :style="triggerButtonStyle"
    >
      {{ modalButtonText }}
    </button>

    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content" :style="modalContentStyle">
        <button @click="showModal = false" class="modal-close">&times;</button>
        <login-form 
          :is-modal="true" 
          @close-modal="showModal = false"
          @login-success="handleLoginSuccess"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import LoginForm from './LoginForm.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const showModal = ref(false)

const loginStyle = computed(() => window.sms_ir_login?.login_style || {})

const modalButtonText = computed(() => {
  const text = loginStyle.value.modal_button_text
  return (text && text.trim()) ? text : t('login')
})

const triggerButtonStyle = computed(() => {
  const s = loginStyle.value
  return {
    backgroundColor: s.modal_button_bg || '#FFBF00',
    color: s.modal_button_text_color || '#0D0D0D'
  }
})

const modalContentStyle = computed(() => {
  const s = loginStyle.value
  const bg = s.modal_background ?? s.form_background
  if (!bg) return {}
  return { backgroundColor: bg }
})

const handleLoginSuccess = () => {
  showModal.value = false
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  padding: 2rem;
  border-radius: 0.5rem;
  position: relative;
  overflow-y: auto;
}

.modal-close {
  position: absolute;
  top: 2rem;
  right: 2rem;
  font-size: 1.5rem;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px 15px;
}

.smsir-login-button {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
}

.smsir-login-button:hover {
  background: #e9af01;
}

@media screen and (max-width: 640px) {
  .modal-content {
    width: 100%;
    height: 100vh;
  }

  
}
</style> 